export default function ReferralsIcon({ width = 24, height = 24, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M6.6 7.4a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4ZM12.2 14.602a5.6 5.6 0 1 0-11.2 0v2.4h2.404l.8 8h4.8l.8-8h2.4l-.004-2.4Z'
      />
      <path stroke='currentColor' strokeWidth='2' d='M20.2 17.4a.4.4 0 0 1 0-.8M20.2 17.4a.4.4 0 0 0 0-.8' />
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M20.2 12.2A4.8 4.8 0 0 1 25 17c0 2.049-2.868 5.949-4.17 7.615a.798.798 0 0 1-.981.226.799.799 0 0 1-.28-.226c-1.302-1.665-4.17-5.565-4.17-7.614a4.802 4.802 0 0 1 4.8-4.801ZM13.004 1h4a3.2 3.2 0 0 1 3.2 3.2V9'
      />
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M17 5.8 20.2 9l3.2-3.2'
      />
    </svg>
  );
}
